/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Rise`)
};

const es_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subida de Precio`)
};

const de_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisanstieg`)
};

const nl_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijsstijging`)
};

const fr_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hausse de prix`)
};

const it_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumento prezzo`)
};

const pt_br2_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alta de preço`)
};

const pt_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subida de preço`)
};

const ja_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格上昇`)
};

const zh_f1_budget_price_rise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格上涨`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_price_rise = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_price_rise(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_price_rise", locale)
	if (locale === "en") return en_f1_budget_price_rise(inputs)
	if (locale === "es") return es_f1_budget_price_rise(inputs)
	if (locale === "de") return de_f1_budget_price_rise(inputs)
	if (locale === "nl") return nl_f1_budget_price_rise(inputs)
	if (locale === "fr") return fr_f1_budget_price_rise(inputs)
	if (locale === "it") return it_f1_budget_price_rise(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_price_rise(inputs)
	if (locale === "pt") return pt_f1_budget_price_rise(inputs)
	if (locale === "ja") return ja_f1_budget_price_rise(inputs)
	return zh_f1_budget_price_rise(inputs)
};